/**
 * @generated SignedSource<<661d56dcf935494b9b452e6650d564f5>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type AddonOperationResultType = "ADDON_NOT_FOUND" | "DEVELOPMENT_STORE_ERROR" | "GENERIC_ERROR" | "NO_PREMIUM" | "SUCCESS";
export type activateAddonDialogMutation$variables = {
  addonId: number;
};
export type activateAddonDialogMutation$data = {
  readonly activateAddon: AddonOperationResultType;
};
export type activateAddonDialogMutation = {
  response: activateAddonDialogMutation$data;
  variables: activateAddonDialogMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "addonId"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "addonId",
        "variableName": "addonId"
      }
    ],
    "kind": "ScalarField",
    "name": "activateAddon",
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "activateAddonDialogMutation",
    "selections": (v1/*:: as any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Operation",
    "name": "activateAddonDialogMutation",
    "selections": (v1/*:: as any*/)
  },
  "params": {
    "cacheID": "d0b9c671bee7c2a91b4e1369fb4f1041",
    "id": null,
    "metadata": {},
    "name": "activateAddonDialogMutation",
    "operationKind": "mutation",
    "text": "mutation activateAddonDialogMutation(\n  $addonId: Long!\n) {\n  activateAddon(addonId: $addonId)\n}\n"
  }
};
})();

(node as any).hash = "7d8c3563ec913d0426e83162d13c3612";

export default node;
